export default __webpack_public_path__ + "static/media/Tasset of Black Spite.a4606963.jpg";